import { render, staticRenderFns } from "./OverlaysControllerOverlayCard.vue?vue&type=template&id=33bb953e&scoped=true&"
import script from "./OverlaysControllerOverlayCard.vue?vue&type=script&lang=ts&"
export * from "./OverlaysControllerOverlayCard.vue?vue&type=script&lang=ts&"
import style0 from "./OverlaysControllerOverlayCard.vue?vue&type=style&index=0&id=33bb953e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb953e",
  null
  
)

export default component.exports